import login from './service';
export default {
    login
};